import React, { ChangeEvent, useState } from 'react'
import styled from 'styled-components'
import { useParams } from 'react-router-dom'

// Constants
import { SKETCH_WEBSITE } from 'constants/sketchWebsite'
import { RouteParams } from 'constants/routes'

// Utils
import { useQueryParams } from 'utils'

// Components
import PageLayout from 'layouts/PageLayout'
import Footer from 'components/Footer'
import Panel from 'components/Panel'
import Button from 'components/Button'
import Caption from 'components/Caption'
import Checkbox from 'components/Checkbox'
import { DynamicLoadingPage } from 'containers/DynamicLoadingPage'
import GenericErrorView from 'views/GenericErrorView'
import { goToLinkAccountUrl } from 'modules/sso/operations'

// Types
import { useGetPublicWorkspaceQuery } from 'gqlTypes'

// Styles
const StyledPanel = styled(Panel)`
  max-width: 520px;
  margin: auto;
`

const StyledCheckbox = styled(Checkbox)`
  margin-top: 28px;
`

export const SsoTosPage = () => {
  const [hasAcceptedTos, setHasAcceptedTos] = useState(false)
  const { workspaceId } = useParams<RouteParams<'SSO_TOS'>>()
  const queryParams = useQueryParams<'SSO_TOS'>()
  const { data, loading, error } = useGetPublicWorkspaceQuery({
    variables: { identifier: workspaceId },
  })

  if (loading) {
    return <DynamicLoadingPage />
  }

  if (error || !data) {
    return <GenericErrorView />
  }

  return (
    <PageLayout showHeader={false} footer={<Footer />}>
      <StyledPanel>
        <Panel.Title>Terms of Service</Panel.Title>
        <Panel.Body>
          <Caption>
            Before proceeding, please confirm you have read and agree to the{' '}
            <b>
              Sketch Cloud{' '}
              <a
                href={`${SKETCH_WEBSITE}/tos`}
                target="_blank"
                rel="noopener noreferrer">
                Terms of Service
              </a>
            </b>
            .
          </Caption>

          <StyledCheckbox
            name="acceptTos"
            checked={hasAcceptedTos}
            onChange={(event: ChangeEvent<HTMLInputElement>) => {
              setHasAcceptedTos(event.target.checked)
            }}>
            I accept the terms of service.
          </StyledCheckbox>
        </Panel.Body>
        <Panel.Footer>
          <Button
            variant="primary"
            disabled={!hasAcceptedTos}
            onClick={() =>
              goToLinkAccountUrl({
                url: data!.publicWorkspace!.customer!.ssoStartUrl!,
                ...queryParams,
              })
            }>
            Continue
          </Button>
        </Panel.Footer>
      </StyledPanel>
    </PageLayout>
  )
}
